export default "__VITE_ASSET__8B71$4ec1J6Po6IJYp4VSw__"